import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import { createPortal } from "react-dom";
import stl from "./BottomSheetPopup.module.css";
import useIsBrowser from "@hooks/useIsBrowser";
import useIsWebView from "@hooks/useIsWebview";
var BottomSheetPopup = function BottomSheetPopup(_ref) {
  var show = _ref.show,
    onClose = _ref.onClose,
    children = _ref.children,
    _ref$mobileDesignChan = _ref.mobileDesignChange1,
    mobileDesignChange1 = _ref$mobileDesignChan === void 0 ? "" : _ref$mobileDesignChan,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$blueCloseIcon = _ref.blueCloseIcon,
    blueCloseIcon = _ref$blueCloseIcon === void 0 ? "" : _ref$blueCloseIcon,
    _ref$noX = _ref.noX,
    noX = _ref$noX === void 0 ? false : _ref$noX,
    _ref$showXMob = _ref.showXMob,
    showXMob = _ref$showXMob === void 0 ? false : _ref$showXMob,
    _ref$noPadding = _ref.noPadding,
    noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding,
    _ref$containerClassNa = _ref.containerClassName,
    containerClassName = _ref$containerClassNa === void 0 ? "" : _ref$containerClassNa;
  useEffect(function () {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [show]);
  var canUseDOM = useIsBrowser();
  var isWebView = useIsWebView();
  var renderPopUpHTML = function renderPopUpHTML() {
    // show && (document.body.style.overflow = show ? "hidden" : "");
    return /*#__PURE__*/React.createElement(React.Fragment, null, show && /*#__PURE__*/React.createElement("div", {
      className: [stl.genralPopUp, isWebView ? "webview" : "", containerClassName].join(" "),
      onClick: function onClick(e) {
        if (e.target === e.currentTarget) {
          onClose();
          document.body.style.overflow = "";
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(stl.genralPopUpContent, " ").concat(className ? className : "")
    }, !noX && /*#__PURE__*/React.createElement("span", {
      className: [stl.closeGenralPopUp, blueCloseIcon ? blueCloseIcon : undefined, stl.Desc, "m-hide"].join(" "),
      onClick: function onClick() {
        onClose();
        document.body.style.overflow = "";
      }
    }), (!noX || showXMob) && /*#__PURE__*/React.createElement("span", {
      className: [stl.closeGenralPopUp, stl.Mobile, "m-show", mobileDesignChange1 ? stl.mobileDesignChange1 : undefined].join(" "),
      onClick: function onClick() {
        onClose();
        document.body.style.overflow = "";
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: [stl.genralModalbody, noPadding ? stl.noPadding : undefined].join(" ")
    }, /*#__PURE__*/React.createElement("div", null, children)))));
  };
  return canUseDOM ? (/*#__PURE__*/createPortal(renderPopUpHTML(), document.getElementById("BodyPortal"))) : /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default BottomSheetPopup;